/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import '../../../vlinder.min.css';
import { useTheme } from '../../../providers/theme';
import {
  PageContainer,
  Logo,
  Heading,
  TermsText,
  SubmitButton,
  GoBackLink,
  FormComp,
  AlertComp,
  OTPComp,
  LeftContainer,
  RightContainer,
  BodyTitle,
  BodyContainer,
  ProgressBar,
  RoeSignupForm,
} from '../components';
import { useRegisterToken } from '../provider';
import {
  useSMRegisterPageGetContent,
  useSMSignUpUser,
  useSMSendOTP,
} from '../machines/';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { vappContainer } from '@/application';
import { SignUpPageService } from '../services';
import { HtmlPage as HtmlPageWidget } from '@widgets/landing-page-widget';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { Button, Form, Modal } from 'react-bootstrap';
import { Loader } from '@/components';
import { SelectInput } from '../components/FormComponent/components';

const getSrv = () => {
  return vappContainer.get<SignUpPageService>(SignUpPageService.displayName);
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectForm, setselectForm] = useState('');
  const [activeStep, setActiveStep] = useState(0);

  const srv = getSrv();
  const _email = srv?.getUserEmail();
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const { signUpUserSend, signUpUserState } = useSMSignUpUser({});
  const { registerPageGetContentState } = useSMRegisterPageGetContent({});
  const { sendOTPSend, sendOTPState } = useSMSendOTP({});
  const [userData, setUserData] = useState<any>();
  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  useEffect(() => {
    if (
      signUpUserState.matches('SIGN_UP_USER_SUCCESS') &&
      signUpUserState?.event?.data?.value
    ) {
      setUserData(null);
      toast.success('Email verified successfully. You can now sign in.');
      setTimeout(() => {
        navigate('/sign-in');
      }, 500);
    }
  }, [
    signUpUserState.matches('SIGN_UP_USER_SUCCESS') &&
      signUpUserState?.event?.data?.value,
  ]);

  useEffect(() => {
    if (
      (signUpUserState.matches('SIGN_UP_USER_FAILED') ||
        signUpUserState.matches('VERIFY_USER_FAILED')) &&
      signUpUserState?.event?.data?.value
    ) {
      toast.error(signUpUserState?.event?.data?.value);
    }
  }, [
    signUpUserState.matches('SIGN_UP_USER_FAILED') &&
      signUpUserState?.event?.data?.value,
  ]);

  const onRegisterSubmit = (data: any) => {
    setUserData(data);
    console.log(`register submit`, data);
    const combinedRole = data?.userType || selectForm;
    console.log('combined roles', selectForm);
    const filteredData = { ...data };
    // delete filteredData.userType;
    srv?.setUserEmail(data?.email);

    signUpUserSend('START', {
      payload: {
        ...filteredData,
        role: combinedRole,
        optionSelected: selectForm,
        // jwtToken: registerPageGetContentState?.event?.data?.value?.token,
      },
    });
  };

  const onOtpLoginSubmit = (formData: any) => {
    console.log(`on otp login submit`, formData);
    const __email = srv?.getUserEmail();
    signUpUserSend('VERIFY_USER_START', {
      payload: {
        email: __email,
        otp: formData?.otp,
      },
    });
  };

  const onStepperClose = () => {
    props?.onCloseClick && props?.onCloseClick();
    navigate('/sign-in');
  };

  useEffect(() => {
    if (
      signUpUserState.matches('VERIFY_USER_FAILED') &&
      signUpUserState?.event?.data?.value
    ) {
      toast.error(signUpUserState?.event?.data?.value);
    }
  }, [
    signUpUserState.matches('VERIFY_USER_FAILED') &&
      signUpUserState?.event?.data?.value,
  ]);

  const onDOBSubmit = (data: any) => {
    if (data?.dob) {
      setActiveStep(activeStep + 1);
    }
    // setActiveStep(activeStep+1);
  };
  const [employeetye, setEmployeeType] = useState('');
  const renderSignUp = () => {
    return (
      <>
        {
          <PageContainer>
            {/* <Logo logoURL={staticPageContentConfig?.logo} /> */}
            <GoBackLink />
            <Heading title={staticPageContentConfig?.title} />
            <FormComp
              employeetype={selectForm}
              isOwner={
                userData?.userType === 'owner' ||
                userData?.userType === 'roe' ||
                selectForm === 'owner' ||
                selectForm === 'roe'
              }
              renderSubmitButton={renderSubmitButton}
              initialData={
                registerPageGetContentState?.event?.data?.value?.initialData ||
                userData ||
                {}
              }
              onFormSubmit={onRegisterSubmit}
              isPasswordField={
                true
                //!!registerPageGetContentState?.event?.data?.value?.isPassword
              }
            />
            <TermsText />
          </PageContainer>
        }
        {/* <div className='d-flex justify-content-center'>
        {employeetye==='roe' && <RoeSignupForm onsubmit={onRegisterSubmit}/>}

      </div> */}
      </>
    );
  };

  const _renderSubmitButton = () => {
    return (
      <div
        className="mt-3"
        style={{ justifyContent: 'center', display: 'flex' }}
      >
        <Button
          variant="primary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '25%',
            // borderRadius: '5px',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {'Next'}
        </Button>
      </div>
    );
  };

  const handleSubmit = (e?: any) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    setActiveStep(activeStep + 1);
  };

  const getDateOfBirthForm = () => {
    return (
      <div className="d-flex" style={{ width: '90%' }}>
        <LeftContainer>
          <BodyTitle
            {...(staticPageContentConfig?.bodyTitle?.selectCountry || {})}
          />
          {/* <TweetyWidget
            labelColor={'#104382'}
            fields={staticPageContentConfig?.selectFields}
            key={new Date().toString()}
            onFormSubmit={(payload: any) => {
              setselectForm(payload?.type);
              setActiveStep(activeStep + 1);
            }}
            renderSubmitButton={_renderSubmitButton}
          /> */}
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <SelectInput
                id={'type'}
                label={'Applicant Type'}
                required={true}
                errorText={'This field is required'}
                options={[
                  {
                    id: 'prospective_employee',
                    label: 'Applicant',
                  },
                  {
                    id: 'owner',
                    label: 'Employer',
                  },
                  {
                    id: 'roe',
                    label: 'Rights Of Establishment',
                  },
                ]}
                onCompChange={(id, payload) => setselectForm(payload)}
              />
            </Form.Group>
            {_renderSubmitButton()}
          </Form>
        </LeftContainer>
        <RightContainer
          rightBlockContent={
            staticPageContentConfig?.rightBlockContent?.selectCountry
          }
        />
      </div>
    );
  };

  const _renderBody = () => {
    switch (activeStep) {
      case 0:
        return (
          <div className="d-flex justify-content-center">
            {getDateOfBirthForm()}
          </div>
        );
      case 1:
        return renderSignUp();
    }
  };

  const onActiveStepChange = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const onOtpResend = () => {
    const __email = srv?.getUserEmail();
    sendOTPSend('START', {
      payload: {
        email: __email,
      },
    });
  };

  const _getPageContent = () => {
    console.log(`signUpUserState`, signUpUserState);
    if (
      (signUpUserState.matches('VERIFY_USER_INTERMEDIATE') ||
        signUpUserState.matches('VERIFY_USER_FAILED')) &&
      signUpUserState?.event?.data?.value
    ) {
      console.log(
        `on otp login submit signUpUserState`,
        signUpUserState?.event?.data?.value
      );
      return (
        <PageContainer>
          {' '}
          <Logo logoURL={staticPageContentConfig?.logo} />
          <GoBackLink />
          <Heading
            title={`${staticPageContentConfig?.otpScreenTitle} ( ${_email} )`}
          />
          <OTPComp
            onResendClick={onOtpResend}
            renderSubmitButton={renderSubmitButton}
            onFormSubmit={onOtpLoginSubmit}
          />
        </PageContainer>
      );
    }
    if (registerPageGetContentState?.matches('RENDER_PAGE')) {
      return (
        <>
          <HtmlPageWidget
            {...staticPageContentConfig}
            headerLogo={staticPageContentConfig?.header?.headerLogo}
            // buttonItem={buttonItem}
          >
            <ProgressBar
              onActiveStepChange={onActiveStepChange}
              activeStep={activeStep}
              totalSteps={1}
              onCloseClick={onStepperClose}
              setemployeetype={setEmployeeType}
            />
            <BodyContainer>{_renderBody()}</BodyContainer>
          </HtmlPageWidget>
        </>
      );
    }
    return <></>;
  };

  if (
    signUpUserState.matches('SIGN_UP_USER') ||
    signUpUserState.matches('VERIFY_USER')
  ) {
    return (
      <div style={{ paddingTop: '20px' }}>
        <Loader {...(staticPageContentConfig?.loading?.registerUser || {})} />
      </div>
    );
  } else if (registerPageGetContentState?.matches('GET_PAGE_CONTENT')) {
    return (
      <Loader {...(staticPageContentConfig?.loading?.GetPageLoading || {})} />
    );
  } else {
    return _getPageContent();
  }
};
